import React from "react";
import Loadable from "../../react-loadable";

const WeaButton = Loadable({
  loader: () => import("./Button"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaButton;



// WEBPACK FOOTER //
// ./ecology9/wea-button/index.js